module.exports = "<div class=\"row\" ng-if=\"!infiniteScrollCtrl.hideShowMore\">\n  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\" >\n    <a ng-click=\"infiniteScrollCtrl.showMore()\">Show More</a>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/infiniteScroll/template.html
// module id = 1603
// module chunks = 0